const toastStyles = {
    success: {
        title: 'Success',
        border:
            'border-emerald-200 dark:border-emerald-900',
        icon:
            'bg-emerald-100 text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300',
        svg: `
            <svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true"
            >
                <path d="m8 12 3 3 5-6"></path>
                <circle cx="12" cy="12" r="9"></circle>
            </svg>
        `,
    },

    error: {
        title: 'Something went wrong',
        border:
            'border-red-200 dark:border-red-900',
        icon:
            'bg-red-100 text-red-700 dark:bg-red-400/10 dark:text-red-300',
        svg: `
            <svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true"
            >
                <path d="M12 8v5"></path>
                <path d="M12 17h.01"></path>
                <circle cx="12" cy="12" r="9"></circle>
            </svg>
        `,
    },

    warning: {
        title: 'Attention',
        border:
            'border-amber-200 dark:border-amber-900',
        icon:
            'bg-amber-100 text-amber-700 dark:bg-amber-400/10 dark:text-amber-300',
        svg: `
            <svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true"
            >
                <path d="M12 9v4"></path>
                <path d="M12 17h.01"></path>
                <path d="M10.3 3.7 2.6 17a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0Z"></path>
            </svg>
        `,
    },

    info: {
        title: 'Information',
        border:
            'border-blue-200 dark:border-blue-900',
        icon:
            'bg-blue-100 text-blue-700 dark:bg-blue-400/10 dark:text-blue-300',
        svg: `
            <svg
                class="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                aria-hidden="true"
            >
                <path d="M12 11v5"></path>
                <path d="M12 8h.01"></path>
                <circle cx="12" cy="12" r="9"></circle>
            </svg>
        `,
    },
};

const initializedToasts = new WeakSet();

function dismissToast(toast) {
    if (
        !toast
        || toast.dataset.dismissing === 'true'
    ) {
        return;
    }

    toast.dataset.dismissing = 'true';

    toast.classList.add(
        'translate-y-[-0.75rem]',
        'opacity-0'
    );

    window.setTimeout(
        () => {
            toast.remove();
        },
        300
    );
}

function initializeToast(toast) {
    if (
        !toast
        || initializedToasts.has(toast)
    ) {
        return;
    }

    initializedToasts.add(toast);

    const requestedType =
        toast.dataset.toastType
        || 'info';

    const type =
        toastStyles[requestedType]
            ? requestedType
            : 'info';

    const style =
        toastStyles[type];

    style.border
        .split(' ')
        .forEach(
            className => {
                toast.classList.add(
                    className
                );
            }
        );

    const icon =
        toast.querySelector(
            '[data-toast-icon]'
        );

    style.icon
        .split(' ')
        .forEach(
            className => {
                icon?.classList.add(
                    className
                );
            }
        );

    if (icon) {
        icon.innerHTML =
            style.svg;
    }

    const title =
        toast.querySelector(
            '[data-toast-title]'
        );

    if (
        title
        && !title.textContent.trim()
    ) {
        title.textContent =
            style.title;
    }

    toast
        .querySelector(
            '[data-toast-close]'
        )
        ?.addEventListener(
            'click',
            () => {
                dismissToast(
                    toast
                );
            }
        );

    const duration =
        Number.parseInt(
            toast.dataset.toastDuration
            || '6000',
            10
        );

    if (
        Number.isFinite(duration)
        && duration > 0
    ) {
        window.setTimeout(
            () => {
                dismissToast(
                    toast
                );
            },
            duration
        );
    }
}

function initializeToasts() {
    document
        .querySelectorAll(
            '[data-toast]'
        )
        .forEach(
            initializeToast
        );
}

function showToast({
                       type = 'info',
                       title = '',
                       message = '',
                       duration = 6000,
                   } = {}) {
    const container =
        document.querySelector(
            '[data-toast-container]'
        );

    if (!container) {
        return null;
    }

    const toast =
        document.createElement(
            'div'
        );

    toast.dataset.toast = '';
    toast.dataset.toastType =
        type;

    toast.dataset.toastDuration =
        String(duration);

    toast.className = [
        'pointer-events-auto',
        'flex',
        'w-full',
        'max-w-sm',
        'overflow-hidden',
        'rounded-2xl',
        'border',
        'bg-white',
        'text-slate-900',
        'shadow-2xl',
        'transition',
        'duration-300',
        'dark:bg-slate-950',
        'dark:text-white',
    ].join(' ');

    const safeTitle =
        String(title);

    const safeMessage =
        String(message);

    toast.innerHTML = `
        <div
            class="flex h-12 w-12 shrink-0 items-center justify-center"
            data-toast-icon
        ></div>

        <div class="min-w-0 flex-1 p-4">
            <div
                class="font-bold"
                data-toast-title
            ></div>

            <div
                class="mt-1 text-sm text-slate-600 dark:text-slate-300"
                data-toast-message
            ></div>
        </div>

        <button
            type="button"
            class="shrink-0 px-4 text-slate-400 transition hover:text-slate-900 dark:hover:text-white"
            data-toast-close
            aria-label="Dismiss notification"
        >
            ✕
        </button>
    `;

    const titleElement =
        toast.querySelector(
            '[data-toast-title]'
        );

    const messageElement =
        toast.querySelector(
            '[data-toast-message]'
        );

    if (titleElement) {
        titleElement.textContent =
            safeTitle;
    }

    if (messageElement) {
        messageElement.textContent =
            safeMessage;
    }

    container.appendChild(
        toast
    );

    initializeToast(
        toast
    );

    return toast;
}

document.addEventListener(
    'DOMContentLoaded',
    initializeToasts
);

document.addEventListener(
    'livewire:navigated',
    initializeToasts
);

window.initializeToast =
    initializeToast;

window.showToast =
    showToast;

initializeToasts();